// @ts-nocheck
            const servicePath = __webpack_public_path__ + "worker-index-e18fce43.js";
            export default servicePath;
            